var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUUpLeft = function SvgArrowUUpLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6v7.5a6.5 6.5 0 1 1-13 0V7.83l-3.09 3.09L2.5 9.5 8 4l5.5 5.5-1.41 1.41L9 7.83v5.67C9 16 11 18 13.5 18s4.5-2 4.5-4.5V6z"
  })));
};
export default SvgArrowUUpLeft;